import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@mui/material';

import './DeleteConfirmationModal.scss';


interface RestoreUserConfirmationModalProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const RestoreUserConfirmationModal: React.FC<RestoreUserConfirmationModalProps> = ({
  open,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog className="delete-confirm-dialog" open={open}>
      <DialogTitle>Restore User</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          Are you sure you want to restore this user?
        </DialogContentText>

        <div className="flex_row_jbetween action-buttons">
          <Button
            variant="outlined"
            onClick={onClose}
            disableElevation
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={onConfirm}
            disableElevation
          >
            Restore User
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RestoreUserConfirmationModal;
